<template>
    <div class="az-form-content">
        <v-btn v-if="exibirBtnLancarProposta" :color="btnLancarPropostaColor" :outline="btnLancarPropostaOutline"
               class="botao-acao"
               @click="iniciarCredenciamento" :disabled="!dadosCarregados"
               :loading="carregamento">
            <v-icon small class="icone-botao">add_circle</v-icon>
            Lançar Proposta
        </v-btn>
        <LicitacaoMensagemCerca :ehCercaValido="propostaResumo.ehCercaValido"/>
        <modal-confirm v-if="exibirModalBeneficioLocal" :maxWidth=390
                       label-confirm="OK" :show-decline="false"
                       @onConfirm="fecharModalBeneficioLocal">
            <div style="text-align: justify">
                <v-icon color="#FFD22D">warning</v-icon>
                <label>
                    Esta licitação permite somente a participação de empresas regionais e locais conforme definido no
                    edital.
                </label>
            </div>
        </modal-confirm>
        <az-dialog v-if="isCredenciamentoIniciado && !isFornecedorAprovado"
                   :width=450 @ok="cancelarCredenciamento">
            <div>
                <span>Caro senhor fornecedor, seu cadastro ainda não está homologado.</span><br/>
                <span>Por favor entre em contato com o suporte</span>
            </div>
        </az-dialog>
        <licitacao-fornecedor-termos v-if="isCredenciamentoIniciado && isFornecedorAprovado"
                                     @concluido="finalizarAceiteTermos"
                                     @fechar="cancelarCredenciamento"/>
        <lotes-itens/>

        <licitacao-fornecedor-inconsistencias-fornecedor :inconsistencias="inconsistenciasCadastroFornecedor"
                                                         :mostrar="mostrarDialogFornecInfoIncompleta"
                                                         @ok="mostrarDialogFornecInfoIncompleta = false"/>

        <plano-assinatura :renderizar="mostrarDialogConfirmarPlanoFornecedor"
                          :status-fornecedor="isFornecedorAprovado"
                          :plano-expirado="planoAssinaturaExpirado"
                          :plano-pendente="planoAssinaturaPendente"
                          :quantidade-planos="quantidadePlanos"
                          @fechar="fecharModalPlano"/>

        <az-dialog v-if="mostrarDialogFornecImpedido"
                   :width=450 @ok="mostrarDialogFornecImpedido = false">
            <div style="text-align: justify">
                <v-icon color="#FFD22D">warning</v-icon>
                <label> Não é possível lançar proposta existe(m) penalidade(s) vinculada(s).</label><br/><br/>
                <label>Entre em contato com o cadastro de fornecedor.</label>
            </div>
        </az-dialog>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import moment from 'moment'
import {actionTypes} from '@/commons/constants'
import WrapperDialog from '@/commons/components/WrapperDialog'
import LotesItens from '../commons/LotesItens'
import LicitacaoFornecedorTermos from './termos/LicitacaoFornecedorTermos'
import validadorInformacoesFornecedor from './validador-informacoes-fornecedor'
import LicitacaoFornecedorInconsistenciasFornecedor from './LicitacaoFornecedorInconsistenciasFornecedor'
import PlanoAssinatura from './modal/PlanoAssinatura'
import ModalConfirm from '@/commons/components/ModalConfirm.vue'
import LicitacaoMensagemCerca from '@/views/licitacao/detalhe/fornecedor/termos/LicitacaoMensagemCerca.vue'

export default {
    name: 'LicitacaoFornecedorItens',
    components: {
        LicitacaoMensagemCerca,
        ModalConfirm,
        LicitacaoFornecedorInconsistenciasFornecedor,
        LicitacaoFornecedorTermos,
        LotesItens,
        WrapperDialog,
        PlanoAssinatura
    },
    data() {
        return {
            isPropostaIniciada: false,
            isCredenciamentoIniciado: false,
            inconsistenciasCadastroFornecedor: [],
            mostrarDialogConfirmarPlanoFornecedor: false,
            mostrarDialogFornecInfoIncompleta: false,
            planoAssinatura: null,
            planoAssinaturaExpirado: null,
            planoAssinaturaPendente: null,
            quantidadePlanos: 0,
            dadosCarregados: null,
            carregamento: false,
            municipiosBeneficioRegional: [],
            exibirModalBeneficioLocal: false,
            mostrarDialogFornecImpedido: false,
        }
    },
    computed: {
        btnLancarPropostaColor() {
            return this.podeLancarProposta() ? 'secondary' : 'primary'
        },
        btnLancarPropostaOutline() {
            return !this.podeLancarProposta()
        },
        isFornecedorAprovado() {
            return this.loki.user.domainId !== null
        },
        exibirBtnLancarProposta() {
            return this.licitacao.status === 'AGUARDANDO_ABERTURA' && this.licitacao.executarLicitacao && !this.licitacao.modalidade.includes('PRESENCIAL') && this.propostaResumo.ehCercaValido
        },
        ...mapState(['loki', 'licitacao', 'fornecedorAceite', 'propostaResumo'])
    },
    async mounted() {
        this.carregamento = true
        await this.buscarAssinaturas()
        this.dadosCarregados = true
        this.carregamento = false
        await this.buscarLotes()
        if (this.$route.params.iniciarCredenciamento) {
            await this.iniciarCredenciamento()
        }
    },
    methods: {
        finalizarAceiteTermos() {
            this.$emit('termosAceitos')
        },
        async buscarAssinaturas() {
            this.setMensagemLoading('Buscando dados da assinatura...')
            const resultado = await this.buscarDadosAssinaturasFornecedor()
            this.quantidadePlanos = resultado.quantidadeAssinaturas
            if (resultado.assinaturaAtual) {
                this.planoAssinatura = resultado.assinaturaAtual
            } else if (resultado.assinaturaPendente) {
                this.planoAssinaturaPendente = resultado.assinaturaPendente
            } else if (resultado.ultimaAssinaturaExpirada) {
                this.planoAssinaturaExpirado = resultado.ultimaAssinaturaExpirada
            }
        },
        async buscarLotes() {
            this.setMensagemLoading('Atualizando listagem de lotes...')
            await this.buscarLotesItemPorLicitacao(this.$route.params.id)
        },
        cancelarCredenciamento() {
            this.isCredenciamentoIniciado = false
        },
        getDataAtual() {
            return moment()
        },
        async iniciarCredenciamento() {
            await this.buscarDadosProposta()
            if (!this.podeLancarProposta()) {
                if (this.licitacao.tipoLicitacao === 'CA') {
                    this.mostrarNotificacaoErro('Não é possível enviar propostas para esse tipo de licitação (Conteúdo Artístico).')
                    return
                }
                if (this.licitacao.status !== 'AGUARDANDO_ABERTURA') {
                    this.mostrarNotificacaoErro('Só é possível efetuar propostas em licitações com o status "Aguardando Abertura".')
                } else {
                    this.mostrarNotificacaoErro('Não é possível lançar proposta após a Data/Hora Fim Envio de Propostas.')
                }
            } else if (!this.planoAssinatura) {
                this.mostrarDialogConfirmarPlanoFornecedor = true
            } else if (!this.isFornecedorComInformacoesValidas()) {
                this.mostrarDialogFornecInfoIncompleta = true
            } else if (!this.validarMunicipiosBeneficioRegional()) {
                this.exibirModalBeneficioLocal = true
            } else if (this.validarImpedimentoForne()) {
                this.mostrarDialogFornecImpedido = true
            } else {
                this.isCredenciamentoIniciado = true
            }
        },
        isFornecedorComInformacoesValidas() {
            const inconsistencias = validadorInformacoesFornecedor.validar(this.fornecedorAceite)
            if (inconsistencias.totalInconsistencias > 0) {
                this.inconsistenciasCadastroFornecedor = inconsistencias
                return false
            }
            return true
        },
        async fecharModalPlano() {
            this.mostrarDialogConfirmarPlanoFornecedor = false
            await this.buscarAssinaturas()
        },
        podeLancarProposta() {
            if (this.licitacao.status !== 'AGUARDANDO_ABERTURA')
                return false

            if (this.licitacao.tipoLicitacao === 'CA')
                return false
            return this.propostaResumo.licitacaoAbertaParaPropostas
        },
        validarMunicipiosBeneficioRegional() {
            if (this.licitacao.beneficioRegional) {
                return (this.licitacao.beneficiosRegionais || []).some(beneficio => this.beneficioContemplaFornecedor(beneficio))
            }
            return true
        },
        beneficioContemplaFornecedor(beneficio) {
            // Mesma regra do backend: benefício sem município contempla o estado inteiro;
            // com município, compara nome e UF (o município do fornecedor é de outra tabela, os ids não batem)
            const {municipioFornecedor, ufFornecedor} = this.fornecedorAceite
            if (!beneficio.municipio) {
                return !!beneficio.estado && this.textosIguais(beneficio.estado.sigla, ufFornecedor)
            }
            const estadoMunicipio = beneficio.municipio.estado || beneficio.estado
            return this.textosIguais(beneficio.municipio.nome, municipioFornecedor)
                && !!estadoMunicipio && this.textosIguais(estadoMunicipio.sigla, ufFornecedor)
        },
        textosIguais(texto1, texto2) {
            return !!texto1 && !!texto2 && texto1.toUpperCase() === texto2.toUpperCase()
        },
        validarImpedimentoForne() {
            return this.fornecedorAceite.impedimentoFornecedor === 'S'
        },
        fecharModalBeneficioLocal() {
            this.exibirModalBeneficioLocal = false
        },
        async buscarDadosProposta() {
            this.setMensagemLoading('Carregando dados da Proposta...')
            await this.buscarPropostaResumo(this.$route.params.id)
            this.validarLicitacaoPublicada()
        },
        validarLicitacaoPublicada() {
            if (!this.licitacao.publicado) {
                this.$router.push({name: 'licitacaoBuscaMsg', params: {tipo: 'licitacaoexcluida'}})
            }
        },
        ...mapActions([actionTypes.BUSCAR_LOTES_ITEM_POR_LICITACAO,
            actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR,
            actionTypes.BUSCAR_PROPOSTA_RESUMO
        ])
    }
}
</script>

<style scoped lang="stylus">

.v-btn--small
    padding: 0 15px !important

.botao-acao
    margin: 0 0 20px 0
    text-transform: none

    .icone-botao
        margin-right: 5px

</style>
